<template>
  <div class="home-wrapper" v-swipe-menu>
    <!-- components -->
    <Messages />

    <!-- mobile menu -->
    <div
      class="home-mobile-above d-block d-lg-none"
      :class="{ open: showMenu }"
    >
      <div class="sidebar sidebar-above" :class="{ open: showMenu }">
        <MenuSidebar
          v-if="showMenu"
          :toggleMenu="toggleMenu"
          isFromMobile="true"
        />
      </div>
      <div
        class="background-blocked clickable d-none"
        @click="toggleMenu"
        :class="{ 'd-block': showMenu }"
      />
    </div>

    <div class="top">
      <div class="top-bar" />
      <MenuNavbar class="d-block d-lg-none" :toggleMenu="toggleMenu" />
    </div>

    <div class="body">
      <div class="sidebar sidebar-full d-none d-lg-block">
        <MenuSidebar />
      </div>

      <div class="content">
        <router-view />
      </div>
    </div>
    <ModalApp />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import MenuSidebar from '@/components/Home/Menu/Sidebar.vue'
import MenuNavbar from '@/components/Home/MenuNavbar.vue'
import Messages from '@/components/Home/Messages.vue'
import ModalApp from '@/components/Modal/ModalApp.vue'
import { showChat } from '@/helpers/chat'

export default {
  components: {
    MenuNavbar,
    MenuSidebar,
    Messages,
    ModalApp,
  },
  computed: mapGetters({
    resources: 'resources',
  }),
  watch: {
    $route() {
      this.showMenu = false
    },
  },
  data() {
    return {
      showMenu: false,
    }
  },
  created() {
    showChat()
    this.$root.$emit('app:notify:load')
    this.$root.$emit('app:satismeter:showSurvey')
    this.$store.dispatch('tickets/fetchTickets')
    this.$root.$emit('recordPage')
    this.$root.$on('menu::open', this.openMenu)
    this.$root.$on('menu::close', this.closeMenu)
  },
  updated() {
    const notAllowedRoutes = [
      'feedbacks.tickets',
      'feedbacks.tickets.open',
      'custom-surveys.feedbacks.tickets',
      'custom-surveys.feedbacks.tickets.open',
    ]
    if (!notAllowedRoutes.includes(this.$route.name)) {
      showChat()
    }
    this.$root.$emit('app:notify:load')
    this.$root.$emit('recordPage')
  },
  methods: {
    toggleMenu() {
      this.showMenu ? this.closeMenu() : this.openMenu()
    },
    closeMenu() {
      this.showMenu = false
    },
    openMenu() {
      this.showMenu = true
    },
  },
}
</script>

<style scoped lang="scss">
@import '~@/styles/custom/colors';

.home-wrapper {
  display: flex;
  flex-direction: column;
  min-height: 100%;
  width: 100%;

  .home-mobile-above {
    &.open {
      width: 100%;
      height: 100%;
      position: fixed;
      z-index: 999999;
    }

    .background-blocked {
      background-color: map-get($theme-colors, 'gray01');
      opacity: 0.6;
      height: 100%;
      width: 100%;
      position: fixed;
      z-index: 99999;
    }

    .sidebar-above {
      transform: translate(-100%, 0);
      transition: all ease-in-out 0.3s;
      display: block !important;
      position: fixed !important;
      z-index: 999999;
      height: 100%;
      top: 0;
      &.open {
        transform: translate(0, 0);
        transition: all ease-in-out 0.3s;
      }
    }
  }

  .top {
    width: 100%;
    z-index: 0;

    .top-bar {
      background: linear-gradient(220deg, #bc161c, #ff000a);
      height: 2px;
    }
  }

  .body {
    display: flex;
    flex-direction: row;
    width: 100%;
    height: 100%;
    overflow: hidden;

    .sidebar {
      position: relative;
      // z-index: 1;
    }

    .content {
      padding: 0;
      position: relative;
      z-index: 0;
      min-width: 0px;
      flex: 1 1 auto;
      overflow: auto;
      flex-grow: 1;
      --webkit-flex-grow: 1;
    }
  }

  /deep/ .message-content {
    flex-direction: column;
    @media (min-width: 767px) {
      flex-direction: row;
    }
  }

  /deep/ .btn-assign-now {
    background-color: rgba(0, 0, 0, 0);
    color: #000000;
    line-height: 16px;
    margin-left: 20px;
    padding: 15px 40px;

    @media (min-width: 768px) {
      background-color: map-get($theme-colors, 'red02');
      color: map-get($theme-colors, 'white');
    }

    @media (max-width: 1058px) {
      display: block;
      margin: 0 auto;
    }
  }
}
</style>
